import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import type { EmailQuotaBanner as BannerPayload, QuotaAlertLevel } from "../../api/emailQuotaApi";
import { cn } from "@/lib/utils";

const levelStyles: Record<QuotaAlertLevel, string> = {
  OK: "",
  INFO: "border-blue-300 bg-blue-50 text-blue-950",
  WARN: "border-orange-300 bg-orange-50 text-orange-950",
  CRITICAL: "border-red-300 bg-red-50 text-red-950",
  OVERFLOW_ACTIVE: "border-purple-300 bg-purple-50 text-purple-950",
};

type Props = {
  banner: BannerPayload | null;
  className?: string;
};

const EmailQuotaBanner = ({ banner, className }: Props) => {
  if (!banner || banner.level === "OK") {
    return null;
  }
  return (
    <Alert className={cn(levelStyles[banner.level], className)}>
      <AlertTitle>{banner.title}</AlertTitle>
      <AlertDescription>
        <pre className="mt-2 whitespace-pre-wrap font-sans text-sm">{banner.body}</pre>
      </AlertDescription>
    </Alert>
  );
};

export default EmailQuotaBanner;
